import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

// 上司向け: 部下の残業申請（承認待ち）一覧。承認/却下を行う。
export default function SupervisorOvertimeList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const fetchRows = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/employee/subordinate-overtime/');
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchRows(); }, [fetchRows]);

  const approve = async (id) => {
    if (!window.confirm('この残業申請を承認しますか？')) return;
    setBusyId(id);
    try {
      await api.post(`/api/employee/subordinate-overtime/${id}/approve/`);
      await fetchRows();
    } catch (e) {
      alert(e.response?.data?.detail || '承認に失敗しました。');
    } finally {
      setBusyId(null);
    }
  };

  const reject = async (id) => {
    const reason = window.prompt('却下理由を入力してください');
    if (reason === null) return;
    if (!String(reason).trim()) {
      alert('却下理由を入力してください。');
      return;
    }
    setBusyId(id);
    try {
      await api.post(`/api/employee/subordinate-overtime/${id}/reject/`, { reason: String(reason).trim() });
      await fetchRows();
    } catch (e) {
      alert(e.response?.data?.detail || '却下に失敗しました。');
    } finally {
      setBusyId(null);
    }
  };

  const th = { background: '#1e3a5f', color: '#fff', padding: '8px 10px', fontSize: '0.82rem', whiteSpace: 'nowrap', border: '1px solid #2c4a73' };
  const td = { padding: '8px 10px', fontSize: '0.85rem', border: '1px solid #e2e8f0', verticalAlign: 'top' };
  const btn = (bg) => ({ padding: '6px 12px', background: bg, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: '0.8rem' });

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 700, margin: 0 }}>部下の残業申請（承認待ち）</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" onClick={fetchRows} disabled={loading} style={btn('#475569')}>
            {loading ? '更新中…' : '更新'}
          </button>
          <button type="button" onClick={() => navigate(-1)} style={btn('#94a3b8')}>戻る</button>
        </div>
      </div>

      {loading ? (
        <p style={{ color: '#64748b' }}>読み込み中...</p>
      ) : rows.length === 0 ? (
        <p style={{ color: '#64748b' }}>承認待ちの残業申請はありません。</p>
      ) : (
        <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={th}>日付</th>
                <th style={th}>名前（コード）</th>
                <th style={th}>残業</th>
                <th style={th}>理由</th>
                <th style={th}>ステータス</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{row.date || '—'}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{row.applicantName}（{row.applicantMemberId}）</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    {row.overtimeHours || (row.plannedEnd ? `終了予定 ${row.plannedEnd}` : '—')}
                  </td>
                  <td style={{ ...td, whiteSpace: 'pre-line', minWidth: 180 }}>{row.reason || '—'}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      <button type="button" onClick={() => approve(row.id)} disabled={busyId === row.id} style={btn('#16a34a')}>承認</button>
                      <button type="button" onClick={() => reject(row.id)} disabled={busyId === row.id} style={btn('#dc2626')}>却下</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
